export default __webpack_public_path__ + "static/aayushi-26294db2eef0c6c585b57c32e1a55e68.jpg";